import React from 'react';
import useModalStore, { MODAL_TYPES } from '../../stores/useModalStore';

// Import all modals
import TaskModal from '../TaskModal';
import ProjectModal from '../ProjectModal';
import ProjectResourceModal from '../project/ProjectResourceModal';
import PropertyManagerModal from '../properties/PropertyManagerModal';
import FrictionModal from '../FrictionModal/FrictionModal';

export default function ModalManager() {
    const { activeModal, modalProps, closeModal } = useModalStore();

    if (!activeModal) return null;

    return (
        <>
            {activeModal === MODAL_TYPES.TASK_MODAL && (
                <TaskModal 
                    isOpen={true} 
                    onClose={closeModal} 
                    {...modalProps} 
                />
            )}
            
            {activeModal === MODAL_TYPES.PROJECT_MODAL && (
                <ProjectModal
                    isOpen={true}
                    onClose={closeModal}
                    {...modalProps}
                />
            )}
            
            {activeModal === MODAL_TYPES.PROJECT_RESOURCE_MODAL && (
                <ProjectResourceModal 
                    isOpen={true} 
                    onClose={closeModal} 
                    {...modalProps} 
                />
            )}
            
            {activeModal === MODAL_TYPES.PROPERTY_MANAGER_MODAL && (
                <PropertyManagerModal 
                    isOpen={true} 
                    onClose={closeModal} 
                    {...modalProps} 
                />
            )}
            
            {activeModal === MODAL_TYPES.FRICTION_MODAL && (
                <FrictionModal 
                    isOpen={true} 
                    onClose={closeModal} 
                    {...modalProps} 
                />
            )}
        </>
    );
}
